import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import './Personnel.css';

const Personnel = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const personnelSections = [
    {
      id: 'approvals',
      title: 'طلبات الانضمام',
      icon: '🔔',
      description: 'مراجعة والموافقة على طلبات المستخدمين الجدد',
      path: '/approvals',
      color: '#4CAF50'
    },
    {
      id: 'team',
      title: 'أفراد المعامل',
      icon: '👥',
      description: 'عرض وإدارة قائمة موظفي المعامل',
      path: '/lab-team',
      color: '#2196F3'
    },
    {
      id: 'distribution',
      title: 'التوزيع على المحطات',
      icon: '📊',
      description: 'توزيع الأفراد على المحطات المختلفة',
      path: '/station-distribution',
      color: '#FF9800'
    },
    {
      id: 'settings',
      title: 'ضبط الحسابات',
      icon: '⚙️',
      description: 'إدارة الصلاحيات وإعدادات المستخدمين',
      path: '/account-settings',
      color: '#9C27B0'
    }
  ];

  return (
    <div className="dashboard-layout">
      <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      
      <div className="dashboard-content">
        <div className="dashboard-header">
          <button className="menu-toggle" onClick={toggleSidebar}>
            ☰
          </button>
          <h1>إدارة الأفراد</h1>
        </div>

        <div className="dashboard-main">
          <div className="welcome-section">
            <h2>👥 إدارة الأفراد والصلاحيات</h2>
            <p className="user-role">اختر القسم المناسب لإدارة بيانات الموظفين والصلاحيات</p>
          </div>

          <div className="stats-grid">
            {personnelSections.map((section) => (
              <div
                key={section.id}
                className="stat-card personnel-card"
                onClick={() => navigate(section.path)}
                style={{ borderRight: `5px solid ${section.color}` }}
              >
                <div className="stat-icon" style={{ background: `${section.color}15`, color: section.color }}>
                  {section.icon}
                </div>
                <div className="stat-info">
                  <h3>{section.title}</h3>
                  <p>{section.description}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="project-info">
            <h3>نظام إدارة الأفراد</h3>
            <div className="info-grid">
              <div className="info-item">
                <strong>الوظيفة:</strong>
                <span>إدارة شاملة لجميع موظفي المعامل</span>
              </div>
              <div className="info-item">
                <strong>الصلاحيات:</strong>
                <span>التحكم الكامل في صلاحيات المستخدمين</span>
              </div>
              <div className="info-item">
                <strong>التوزيع:</strong>
                <span>توزيع الموظفين على المحطات المختلفة</span>
              </div>
              <div className="info-item">
                <strong>الموافقات:</strong>
                <span>مراجعة والموافقة على طلبات الانضمام</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Personnel;